"use client";

import { useWizard } from "@/app/shared-providers/wizard-context-provider";

import HelpOverLayButton from "./help-overlay-button";

/**
 * Wizard-aware wrapper for HelpOverLayButton that automatically
 * extracts useNewHelpOverlay from the wizard definition's productSpecialFeatures.
 *
 * This component should be used in wizard pages that have access to wizard context.
 * For non-wizard pages (like 404, error), use the base HelpOverLayButton directly
 * and pass the useNewHelpOverlay prop explicitly (or let it read from sessionStorage).
 */
function HelpOverLayButtonWizard(
  props: Readonly<{
    useAbsolutePositioning?: boolean;
  }>
) {
  const { useAbsolutePositioning } = props;
  const { wizard } = useWizard();
  const useNewHelpOverlay =
    wizard?.productSpecialFeatures?.useNewHelpOverlay ?? false;

  return (
    <HelpOverLayButton
      useNewHelpOverlay={useNewHelpOverlay}
      useAbsolutePositioning={useAbsolutePositioning}
    />
  );
}

export default HelpOverLayButtonWizard;
